import { Controller } from "@hotwired/stimulus";

// Connects with data-controller="cache-adapter"
export default class extends Controller {
  static targets = ["warning"];
  static values = { originalAdapter: String };

  declare warningTarget: HTMLElement;
  declare originalAdapterValue: string;

  connect() {
    // Store the original adapter value when the controller connects
    const checkedInput = this.element.querySelector<HTMLInputElement>(
      'input[name="cache_registry[adapter]"]:checked',
    );
    if (checkedInput) {
      this.originalAdapterValue = checkedInput.value;
    }
  }

  maybeShowWarning() {
    const checkedInput = this.element.querySelector<HTMLInputElement>(
      'input[name="cache_registry[adapter]"]:checked',
    );

    if (!checkedInput) {
      return;
    }

    const currentValue = checkedInput.value;
    const hasChanged = currentValue !== this.originalAdapterValue;

    if (hasChanged) {
      this.warningTarget.classList.remove("hidden");
    } else {
      this.warningTarget.classList.add("hidden");
    }
  }
}
